import authAxios from "../utils/authAxios";

const quizClient = {
    /**
     * Формат и методику этот запрос больше не принимает: счётчики верных и неверных
     * лежат на слове, а не на паре «формат и слово», и от того, каким форматом открыта
     * колода, не зависят.
     */
    getQuizzesByDeckId: async (deckId, { page = 0, size = 10 } = {}) => {
        const params = new URLSearchParams({ page, size });
        // Параметры практики необязательны: без них бэкенд отдаёт квизы с нулевым прогрессом.
        return await authAxios(`/api/quiz-info/deck/${deckId}?${params}`, {
            method: 'GET',
        });
    },

    getQuizById: async (quizId) => {
        return await authAxios(`/api/quizzes/${quizId}`, {
            method: 'GET',
        });
    },

    createQuiz: async (quiz) => {
        return await authAxios(`/api/quizzes`, {
            method: 'POST',
            data: quiz,
        });
    },

    updateQuiz: async (quizId, quiz) => {
        return await authAxios(`/api/quizzes/${quizId}`, {
            method: 'PUT',
            data: quiz,
        });
    },

    // Снятие метки — DELETE того же ресурса, а не PUT с label: null. Сервер такой PUT
    // отклоняет: тело без поля label иначе было бы неотличимо от осознанного снятия и
    // молча стирало бы цвет.
    updateQuizLabel: async (quizId, label) => {
        if (!label) {
            return await authAxios(`/api/quizzes/${quizId}/label`, {
                method: 'DELETE',
            });
        }
        return await authAxios(`/api/quizzes/${quizId}/label`, {
            method: 'PUT',
            data: { label },
        });
    },

    deleteQuiz: async (quizId) => {
        return await authAxios(`/api/quizzes/${quizId}`, {
            method: 'DELETE',
        });
    },
};

export default quizClient;
